import i18n from '../../i18n'
import noSpaceRules from './noSpaceRules'

const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

const emailRules = (v) => [
  ...noSpaceRules(v),
  emailRegex.test(v) || i18n.t('warnings.validation.email')
]

export default emailRules
